// This file is now just a re-export of the modularized BatchReleasePage component
import BatchReleasePage from './BatchReleasePage/index';
export default BatchReleasePage;
